import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

// components
import AudienceForm from '_components/taxonomy/audiences'

// services
import { createTaxonomyAudience } from '_services/audience'

// local
import { FIELDS, INITIAL_STATE } from './constants'
import { logErrorAsync } from '_lib/utility'
import { BUTTON_THEME, Header } from '@st-operations/uikit/src/v2'

const CreateTaxonomyAudienceForm = ({ onToggle, taxonomy }) => {
  const history = useHistory()

  const [values, setValues] = useState(INITIAL_STATE)
  const [isLoading, setLoading] = useState(false)

  const handleChange = (field, value) => {
    setValues((v) => ({ ...v, [field.name]: value }))
  }

  const onSave = () => {
    setLoading(true)

    createTaxonomyAudience({ name: values.name, taxonomy })
      .then((data) => {
        // The API answers 2xx with the DMP's own response wrapper, so a create
        // that did not actually produce an audience still lands here. Navigating
        // regardless sent the browser to /audience/undefined, and that page's
        // lookup failed with an ObjectId cast error - which told the user
        // nothing about what went wrong.
        const id = data?.body?._id
        if (!id) {
          logErrorAsync(new Error('Audience create returned no id'))
          return toast.error('Audience was not created. Please try again.')
        }

        toast('Audience created!')
        history.push(`/audience/${id}`)
      })
      .catch((error) => {
        logErrorAsync(error)
        toast.error(error.message)
      })

    setLoading(false)
  }

  return (
    <div className="audience">
      <Header
        title={`${taxonomy.name} > Create Audience`}
        actions={[
          { children: 'Exit', onClick: onToggle, theme: BUTTON_THEME.GHOST },
          { children: isLoading ? 'Creating...' : 'Create', onClick: isLoading ? null : onSave },
        ]}
      />
      <AudienceForm fields={FIELDS} values={values} handleChange={handleChange} />
    </div>
  )
}

CreateTaxonomyAudienceForm.defaultProps = {}

CreateTaxonomyAudienceForm.propTypes = {
  onToggle: PropTypes.func.isRequired,
  taxonomy: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default CreateTaxonomyAudienceForm
